import {Row} from "exceljs";

export const setHeaderRowHeight = (row: Row, height: number) => {
    if (!height) {
        return
    }
    row.height = height;
}